module.exports = __webpack_public_path__ + "static/3-Tri-08-eef8c5e8d2c61f38be30eefa488622b8.png";